module.exports = __webpack_public_path__ + "img/7_fineStaff_gxh.6cc4761d.png";